import CommentButtons from "./CommentButtons";
import MentionList from "./MentionList";
import MentionUserTextEditor from "./mentionUser";

export default function CommentEditor({
    comment,
    handleComment,
    handleMention,
    editorRef,
    isMobile,
    setElementPos,
    mentionListVisible,
    anchorEl,
    elementPos,
    handleMentionClose,
    isLoading,
    handleChange,
    selectedUserForTag,
    handleUserSelect,
    handleSave,
    handleCancel,
    isDisable,
  }) {
    return (
      <div
        className={isMobile ? "mobile-comment-textEditor" : "comment-textEditor"}
        id={"forAnchor"}
        style={{ position: "relative" }}
      >
        <MentionUserTextEditor
          value={comment}
          onChange={handleComment}
          onMention={handleMention}
          setEelementPros={setElementPos}
          minHeight={"140px"}
          ref={editorRef}
        />
        <MentionList
          mentionListVisible={mentionListVisible}
          anchorEl={anchorEl}
          elementPos={elementPos}
          handleMentionClose={handleMentionClose}
          isLoading={isLoading}
          handleChange={handleChange}
          selectedUserForTag={selectedUserForTag}
          handleUserSelect={handleUserSelect}
        />
        <CommentButtons
          handleSave={handleSave}
          handleCancel={handleCancel}
          isDisable={isDisable}
        />
      </div>
    );
  }